<script>
  import Modal from '@components/Modal.svelte';
  import Dropdown from '@components/Dropdown.svelte';
  import Checkbox from '@components/Checkbox.svelte';
  import Button from '@components/Button.svelte';
  import Avatar from '@components/Avatar.svelte';
  import GroupAjax from '@ajax/group';
  import InviteAjax from '@ajax/invite';
  import RequestAccessAjax from '@ajax/request_access';
  import Notification from '@utils/notification';
  import { getCurrentUserStore } from '@stores/current_user';
  import UserList from '@app-components/UserList.svelte';

  import Tagify from '@yaireo/tagify';
  import '@vendor/tagify.css';
  import ListCopier from '@app-components/group/ListCopier.svelte';
  import jQuery from 'jquery';
  const ROLE_OPTIONS = [
    { label: 'Can view', value: 'viewer' },
    { label: 'Can edit', value: 'contributor' },
  ];

  export let showShareModal = false;
  export let group;
  export let mobile = false;

  let view = 'default';
  let saving = false;

  let emails = [];
  let optionalMessageEl;
  let roleSelected = ROLE_OPTIONS[0];

  let isOwner = false;
  let users = [];
  let invites = [];
  let requestAccesses = [];
  let tagifyInstance;

  let currentUser = getCurrentUserStore('default');

  let goToDefaultView = function () {
    tagifyInstance.removeAllTags();
    view = 'default';

    if (mobile) {
      jQuery('.tagify__input').removeAttr('data-placeholder');
    }
  };

  let goToNotifyView = function () {
    users.forEach((u) => (u.checked = false));
    invites.forEach((i) => (i.checked = false));
    emails = [];
    saving = false;

    jQuery('.tagify__input').attr('data-placeholder', 'Type email addresses');

    view = 'notify';
    toggleNotificationUsers(true);
  };

  let goToAddView = function () {
    view = 'add';
    saving = false;
  };

  let close = function () {
    emails = [];
    users = [];
    invites = [];
    requestAccesses = [];

    saving = false;
    showShareModal = false;
    roleSelected = ROLE_OPTIONS[0];
    view = 'default';
  };

  let toggleLinkSharing = async function () {
    var oldPrivacyFlag = group.privacy_flag;
    var newPrivacyFlag = group.privacy_flag == 'public' ? 'private' : 'public';

    if (isOwner) {
      group.privacy_flag = newPrivacyFlag;
    } else {
      Notification.send({
        text: 'Only list owners can update link sharing',
      });
      return;
    }

    try {
      await GroupAjax.update(group, {
        privacy_flag: newPrivacyFlag,
      });
    } catch (err) {
      if (err) {
        group.privacy_flag = oldPrivacyFlag;
      }
    }
  };

  let notify = async function () {
    saving = true;

    let selectedUsers = users
      .filter((u) => {
        return u.checked;
      })
      .map((u) => u.id);

    let selectedInvites = invites
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.id);

    try {
      let resp = await GroupAjax.sendNotification(group, {
        users: selectedUsers,
        invites: selectedInvites,
        emails: emails.map((x) => x.value),
        message: optionalMessageEl.value,
      });

      Notification.send({
        text: resp.msg,
      });

      loadGroup();
      goToDefaultView();
    } catch (err) {
      if (err) {
        if (err.email && err.message && err.message.length > 0) {
          Notification.send({
            text: `${err.email} ${err.message[0]}`,
            type: 'error',
          });
        } else if (err.error) {
          Notification.send({
            text: err.error,
            type: 'error',
          });
        } else {
          Notification.send({
            text: `Error has occurred send notifications. We will look into this!`,
            type: 'error',
          });
        }
      }
    }

    saving = false;
  };

  let share = async function () {
    if (tagifyInstance.getTagElms().length != emails.length) {
      Notification.send({
        text: 'Please fix invalid emails',
        type: 'error',
      });
      return;
    }

    saving = true;

    try {
      await InviteAjax.send(group, {
        role: roleSelected.value,
        emails: emails.map((e) => {
          return e.value;
        }),
        message: optionalMessageEl.value,
      });

      let message = '';
      if (emails.length == 1) {
        message = `Invite sent to ${emails[0].value}`;
      } else {
        message = `${emails.length} invites sent`;
      }

      Notification.send({
        text: message,
      });

      await loadGroup();
      goToDefaultView();
    } catch (err) {
      if (err) {
        if (err.email && err.message && err.message.length > 0) {
          Notification.send({
            text: `${err.email} ${err.message[0]}`,
            type: 'error',
          });
        } else if (err.error) {
          Notification.send({
            text: err.error,
            type: 'error',
          });
        } else {
          Notification.send({
            text: `Error has occurred sending invites. We will look into this!`,
            type: 'error',
          });
        }
      }
    }

    saving = false;
  };

  let initTaggify = function (node) {
    //Add events
    function handleCopy(e) {
      const selection = document.getSelection();
      var copyText = selection.toString();

      e.clipboardData.setData('text/plain', copyText);

      // Stop the default copy
      e.stopPropagation();
      e.preventDefault();
    }

    tagifyInstance = new Tagify(node, {
      keepInvalidTags: true,
      delimiters: ',| ',
      pattern:
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    });

    if (mobile) {
      jQuery('.tagify__input').removeAttr('data-placeholder');
    }

    tagifyInstance.on('focus', function (_e) {
      if (view == 'default') {
        goToAddView();
      }
    });

    tagifyInstance.on('add remove edit:updated', function (_e) {
      emails = tagifyInstance.value;

      if (emails.length > 0) {
        jQuery('.tagify__input').removeAttr('data-placeholder');
      } else {
        jQuery('.tagify__input').attr('data-placeholder', 'Type email addresses');
      }
    });

    // tagifyInstance.DOM.input.addEventListener('paste', handlePaste);
    tagifyInstance.DOM.input.addEventListener('copy', handleCopy);

    return {
      destroy() {
        try {
          tagifyInstance.destroy();
        } catch {}
      },
    };
  };

  let removeUser = async function (user) {
    if (confirm(`Are you sure you want to remove this member (${user.email})?`)) {
      await GroupAjax.removeUser(group, user.id);
      Notification.send({
        text: `Removed ${user.email}`,
      });
      loadGroup();
    }
  };

  let removeInvite = async function (invite) {
    if (confirm(`Are you sure you want to remove this invite (${invite.email})?`)) {
      await InviteAjax.destroy(group, invite.id);
      Notification.send({
        text: `Removed ${invite.email}`,
      });
      loadGroup();
    }
  };

  let updateInviteRole = function (invite, role) {
    InviteAjax.update(group, invite, {
      role: role,
    });
  };

  let updateRole = async function (user, role) {
    await GroupAjax.updateRole(group, user, role);
    user.role = role;
    group.runCallbacks();
  };

  let acceptRequest = async function (ra) {
    try {
      await RequestAccessAjax.accept(group.id, ra);

      Notification.send({
        text: 'Accepted request',
      });
      loadRequestAccesses();
      loadGroup();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let declineRequest = async function (ra) {
    try {
      await RequestAccessAjax.decline(group.id, ra);

      Notification.send({
        text: 'Declined request',
      });
      loadRequestAccesses();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let toggleNotificationUser = function (user) {
    user.checked = !user.checked;
    users = users;
    invites = invites;
  };

  let toggleNotificationUsers = function (selectAll) {
    users.forEach((u) => {
      u.checked = selectAll;
    });
    invites.forEach((i) => {
      i.checked = selectAll;
    });

    users = users;
    invites = invites;
  };

  let loadInvites = async function () {
    if (isOwner) {
      let resp = await InviteAjax.fetch(group);
      invites = resp.map((i) => {
        return {
          name: 'Invited User',
          email: i.email,
          avatar_url: '/images/user-placeholder.png',
          id: i.id,
          role: i.role,
        };
      });
    }
  };

  let loadRequestAccesses = async function () {
    if (isOwner) {
      let resp = await RequestAccessAjax.fetch(group);
      requestAccesses = resp;
    }
  };

  let loadGroup = async function () {
    let resp = await GroupAjax.get(group.id);
    group.set(resp);

    users = group.users.filter((u) => u.role != 'admin');
    let owner = group.users.filter((u) => u.role == 'admin')[0];

    if (currentUser.id && owner && owner.id == currentUser.id) {
      isOwner = true;
    } else {
      isOwner = false;
    }

    loadInvites();
    loadRequestAccesses();
  };

  $: if (view == 'notify' && tagifyInstance) {
    jQuery(tagifyInstance.DOM.scope).addClass('notify-share-width');
  } else if (tagifyInstance) {
    jQuery(tagifyInstance.DOM.scope).removeClass('notify-share-width');
  }

  $: if (showShareModal) {
    loadGroup();
  }
</script>

<style style="text/scss" lang="scss">
  .share-modal {
    .share-label {
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }

    .share-cancel-btn {
      border-radius: 15px;
      width: 40%;
      height: 54px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      padding-top: 15px;
      padding-bottom: 15px;
      height: 54px;
      background: white;
      color: black;
      border: 2px solid #e8e8e8;
      outline: none;
      cursor: pointer;

      &:hover {
        background: black;
        color: white;
        border-color: black;
      }
    }

    .link-sharing-box {
      background: white;
      border-radius: 16px;
      margin: -20px;
      padding: 30px;
      padding-left: 50px;
      padding-right: 50px;
    }

    .list-followers-box {
      background: white;
      border-radius: 16px;
      margin: -20px;
      padding: 30px;
      margin-top: 35px;
      padding-left: 50px;
      padding-right: 50px;
    }

    .optional-message {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
      border-radius: 12px;
      border: 2px solid #ececec;
      padding-left: 21px;
      padding-right: 21px;
      height: 80px;
      min-height: 80px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #495057;
      width: 100%;
      max-width: 100%;
      min-width: 100%;

      &:focus {
        background-color: #f6f4fe;
        border-color: #a893f9;
        outline: 0;
        outline: none;
      }

      &::placeholder {
        opacity: 0.5;
        font-weight: normal;
      }
    }

    * :global(.copy-link) {
      cursor: pointer;
      border: 0px;
      font-weight: 500;
      background: #000000;
      border-radius: 12px;
      color: white;
      width: 82px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }

    .linksharing-checkbox-container {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 32px;

      .togger-enabled {
        background-color: #a893f9 !important;
        border-color: #a893f9 !important;

        &:before {
          transform: translateX(24px) !important;
          background: white !important;
        }
      }

      .ui-toggler {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        border: 2px solid #ececec;
        border-radius: 999px;
        transition: 0.4s;

        &:before {
          position: absolute;
          content: '';
          height: 24px;
          width: 24px;
          left: 4px;
          bottom: 2px;
          background-color: #ececec;
          border-radius: 50%;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
      }
    }
  }

  .notify-btn {
    background: #a893f9;
    box-shadow: 0px 13px 40px rgba(168, 147, 249, 0.394586);
    border-radius: 10px;
    margin-left: 20px;
    color: white;
    padding: 8px;
    padding-left: 12px;
    padding-right: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
      opacity: 0.8;
    }
  }

  .accept-btn {
    background: black;
    color: white;
    padding: 10px;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 12px;
    font-weight: 500;

    &:hover {
      opacity: 0.8;
    }
  }

  .decline-btn {
    background: #fde7e7;
    color: #ff5567;
    padding: 10px;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 12px;
    margin-left: 10px;
    font-weight: 500;

    &:hover {
      opacity: 0.8;
    }
  }

  .modal__close {
    margin-top: 10px;
    background: transparent;
    border: 0;
    cursor: pointer;
    float: right;

    &:hover {
      font-weight: bold;
    }

    &:before {
      content: '\2715';
    }
  }

  .back-btn {
    margin-bottom: 30px;
    margin-top: 10px;
    margin-left: -20px;
    cursor: pointer;
  }

  .single-follower {
    margin-top: 20px;
    display: flex;
    align-items: center;

    .single-follower-checkbox {
      flex-shrink: 0;
      margin-top: -2px;
    }

    .single-follower-container {
      margin-left: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .single-follower-name-email {
      margin-left: 14px;
    }
  }

  .mobile {
    .single-follower {
      margin-top: 10px important;

      .single-follower-container {
        margin-left: 12px !important;
      }

      .single-follower-name-email {
        margin-left: 8px !important;
      }
    }

    .link-sharing-box {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }

    .list-followers-box {
      padding-left: 20px !important;
      padding-right: 40px !important;
    }

    .add-list-followers {
      margin-right: -20px !important;
    }

    .notify-btn {
      margin-left: auto !important;
    }

    .back-btn {
      margin-left: 0px !important;
      zoom: 0.8;
      margin-top: 0px !important;
    }
  }

  * :global(.share-modal-content-class) {
    margin-bottom: 48px !important;
  }
</style>

<div>
  <Modal
    mobile={mobile}
    on:close={close}
    show={showShareModal}
    showCloseButton={false}
    fadeInDuration={200}
    contentClass="share-modal-content-class"
    style="border-radius: 16px; max-width: 550px; background: transparent;">
    <div slot="content" class:mobile={mobile}>
      <div class="share-modal">
        {#if view == 'default'}
          <button class="modal__close" on:click={close} />

          <div class="link-sharing-box">
            <div>
              <span class="share-label">Link sharing</span>
            </div>
            <div style="margin-top: 16px; display: flex; align-items: center">
              <div class="linksharing-checkbox-container">
                <span
                  on:click={toggleLinkSharing}
                  class="ui-toggler"
                  class:togger-enabled={group.privacy_flag == 'public'} />
              </div>
              <span style="flex: 1; opacity: 0.5; font-size: 14px; margin-left: 15px">
                {#if !mobile}
                  Link sharing is turned {group.privacy_flag == 'public' ? 'on' : 'off'}
                {/if}
              </span>
              {#if group.privacy_flag == 'public'}
                <span style="flex-shrink: 0">
                  <ListCopier group={group} mobile={mobile}>
                    <button class="copy-link">Copy Link</button>
                  </ListCopier>
                </span>
              {/if}
            </div>
            {#if mobile}
              <div style="opacity: 0.5; font-size: 14px; margin-top: 12px">
                Link sharing is turned {group.privacy_flag == 'public' ? 'on' : 'off'}
              </div>
            {/if}
          </div>
        {/if}

        {#if isOwner || group.privacy_flag == 'public'}
          <div class="list-followers-box">
            {#if view == 'add' || view == 'notify'}
              <div on:click={goToDefaultView} class="back-btn">
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 11.2854H1"
                    stroke="#1A1A1A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M10 21.5714L1 11.2857L10 1"
                    stroke="#1A1A1A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            {/if}

            {#if view == 'notify'}
              <div>
                <div style="display: flex; align-items: center; margin-left: -20px;">
                  <Dropdown
                    options={[
                      {
                        label: 'Select All',
                        value: true,
                      },
                      {
                        label: 'Select None',
                        value: false,
                      },
                    ]}
                    on:selected={(e) => {
                      toggleNotificationUsers(e.detail.option.value);
                    }} />

                  <div
                    style="flex: 1; text-align: right; margin-top: -10px;
                  font-size: 14px;">
                    <span style="color: #999;">
                      {#if mobile}Selected{:else}Selected list followers{/if}
                    </span>
                    <span style="margin-left: 10px; font-weight: 500;">
                      {users.filter((u) => u.checked).length + invites.filter((i) => i.checked).length}
                    </span>
                  </div>
                </div>

                <div style="max-height: 155px; overflow: auto; margin-bottom: 40px;" class="purple-scrollbar">
                  {#each [users, invites] as x}
                    {#each x as user}
                      <div class="single-follower">
                        <div class="single-follower-checkbox">
                          <Checkbox
                            checked={user.checked}
                            on:change={() => {
                              toggleNotificationUser(user);
                            }} />
                        </div>
                        <div
                          class="single-follower-container"
                          on:click={() => {
                            toggleNotificationUser(user);
                          }}>
                          <Avatar src={user.avatar_url} width={25} user={user} mobile={mobile} />
                          <span class="single-follower-name-email">
                            {#if user.name != 'Invited User'}
                              {user.name}
                            {:else}{user.email}{/if}
                          </span>
                        </div>
                      </div>
                    {/each}
                  {/each}
                </div>
              </div>
            {/if}

            {#if view == 'default' || view == 'add' || view == 'notify'}
              <div class="add-list-followers">
                <span class="share-label">
                  {#if view == 'notify'}
                    Invite additional list followers
                  {:else}Invite list followers{/if}
                </span>
                <div style="display: flex; flex-direction: column;">
                  <div
                    style="margin-top: 14px; flex: 1; position: relative;
                  margin-right: -20px">
                    <input
                      style="-webkit-appearance: none; -moz-appearance: none;
                    appearance: none;"
                      type="text"
                      placeholder="Type email addresses"
                      use:initTaggify />

                    {#if view != 'notify'}
                      <div style="position: absolute; right: 2px; top: 4px;">
                        <Dropdown
                          showSelectedOption={true}
                          options={ROLE_OPTIONS}
                          on:selected={(e) => {
                            roleSelected = e.detail.option;
                          }} />
                      </div>
                    {/if}
                  </div>

                  {#if view == 'add' || view == 'notify'}
                    <div style="margin-top: 20px;">
                      <textarea
                        class="optional-message"
                        placeholder={view == 'notify' ? 'Type your message here' : 'Add optional message'}
                        bind:this={optionalMessageEl} />
                    </div>
                    <div style="margin-top: 20px; text-align: center;">
                      {#if saving}
                        <Button
                          text="<i class='fa fa-spin fa-spinner'></i><span
                        style='margin-left: 7px'>Working</span>"
                          style="width: 153px; height: 54px;" />
                      {:else}
                        <Button
                          text={view == 'notify' ? 'Notify' : 'Share'}
                          style="width: 153px; height: 54px;"
                          on:click={view == 'notify' ? notify : share} />
                      {/if}
                    </div>
                  {/if}
                </div>
              </div>
            {/if}

            <div style="margin-top: 10px;">
              {#if view == 'default' && isOwner}
                <div style="margin-top: 20px;">
                  {#if requestAccesses.length > 0}
                    <div class="share-label" style="margin-bottom: 20px;">
                      <span>Requested access</span>
                      <span
                        style="margin-left: 8px; font-weight: 400; font-size:
                      14px; color: black;">
                        {requestAccesses.length}
                      </span>
                    </div>
                    {#each requestAccesses as ra}
                      <div style="display: flex; margin-bottom: 20px; align-items: {mobile ? 'flex-start' : 'center'};">
                        <div style="width: 32px; height: 32px; flex-shrink: 0">
                          <Avatar
                            src={ra.user ? ra.user.avatar_url : '/images/user-placeholder.png'}
                            user={ra.user}
                            mobile={mobile} />
                        </div>
                        <div style="flex: 1; margin-left: 20px;">
                          <div>
                            {ra.user ? ra.user.name : ra.email}
                          </div>
                          {#if mobile}
                            <div style="height: 37px; margin-top: 18px">
                              <a
                                href="#"
                                on:click|preventDefault={() => {
                                  acceptRequest(ra);
                                }}
                                class="accept-btn">
                                Accept
                              </a>
                              <a
                                href="#"
                                on:click|preventDefault={() => {
                                  declineRequest(ra);
                                }}
                                class="decline-btn">
                                Decline
                              </a>
                            </div>
                          {/if}
                        </div>
                        {#if !mobile}
                          <div style="flex-shrink: 0">
                            <a
                              href="#"
                              on:click|preventDefault={() => {
                                acceptRequest(ra);
                              }}
                              class="accept-btn">
                              Accept
                            </a>
                            <a
                              href="#"
                              on:click|preventDefault={() => {
                                declineRequest(ra);
                              }}
                              class="decline-btn">
                              Decline
                            </a>
                          </div>
                        {/if}
                      </div>
                    {/each}
                    <div style="height: 15px;">&nbsp;</div>
                  {/if}

                  {#if users.length > 0 || invites.length > 0}
                    <div style="margin-right: -20px;">
                      <div
                        class="share-label"
                        style="margin-bottom: 15px; display: flex; align-items:
                      center;">
                        <span>List followers</span>
                        <span
                          style="margin-left: 8px; font-weight: 400; font-size:
                        14px; color: black;">
                          {users.length + invites.length}
                        </span>
                        <span class="notify-btn" on:click={goToNotifyView}>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect width="14" height="14" fill="url(#pattern0)" />
                            <defs>
                              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0" transform="scale(0.00833333)" />
                              </pattern>
                              <image
                                id="image0"
                                width="120"
                                height="120"
                                xlink:href="data:image/png;base64,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" />
                            </defs>
                          </svg>
                          <span style="margin-left: 6px;">Notify</span>
                        </span>
                      </div>

                      <UserList
                        on:role-selected={(e) => {
                          updateRole(e.detail.user, e.detail.role);
                        }}
                        on:remove={(e) => {
                          removeUser(e.detail.data);
                        }}
                        editable={true}
                        showEmails={false}
                        mobile={mobile}
                        users={users} />
                      <UserList
                        on:role-selected={(e) => {
                          updateInviteRole(e.detail.user, e.detail.role);
                        }}
                        on:remove={(e) => {
                          removeInvite(e.detail.data);
                        }}
                        editable={true}
                        showEmails={false}
                        mobile={mobile}
                        users={invites} />
                    </div>
                  {/if}
                </div>
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </Modal>
</div>
